import { DataSource, ProcedureStatusEnum } from "../generated/graphql";
import { ACCESS_STATUS, AccessStatus } from "./accessStatus";

export const getProcedureStatusColor = (
  status: ProcedureStatusEnum
): "success" | "info" | "warning" | "error" | "default" => {
  switch (status) {
    case ProcedureStatusEnum.Completed:
      return "success";
    case ProcedureStatusEnum.InProgress:
      return "info";
    case ProcedureStatusEnum.Preparation:
      return "warning";
    case ProcedureStatusEnum.OnHold:
      return "warning";
    case ProcedureStatusEnum.Stopped:
    case ProcedureStatusEnum.EnteredInError:
    case ProcedureStatusEnum.NotDone:
      return "error";
    default:
      return "default";
  }
};

export const getInvitationStatusColor = (status: string): "success" | "info" | "warning" | "error" | "default" => {
  switch (status.toLowerCase()) {
    case "sent":
      return "success";
    case "sending":
      return "warning";
    case "failed":
      return "error";
    case "completed":
      return "info";
    default:
      return "default";
  }
};

export const getDeviceStatusColor = (status: string): "success" | "default" =>
  status.toLowerCase() === "active" ? "success" : "default";

export const getAccessStatusColor = (status: AccessStatus): "success" | "warning" | "error" | "default" => {
  switch (status) {
    case ACCESS_STATUS.Active:
      return "success";
    case ACCESS_STATUS.OtpPending:
      return "warning";
    case ACCESS_STATUS.NoAccess:
    case ACCESS_STATUS.Blocked:
      return "error";
    case ACCESS_STATUS.Deactivated:
    default:
      return "default";
  }
};

export const getProcedureSourceSystemColor = (source: DataSource): "primary" | "secondary" | "info" | "default" => {
  switch (source) {
    case DataSource.Senso:
      return "primary";
    case DataSource.Vivendi:
      return "secondary";
    case DataSource.M4C:
      return "info";
    default:
      return "default";
  }
};
